module.exports = __webpack_public_path__ + "static/img/company-3.920206d7.png";